import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';

/** @type {string} State */
const initialState = {};

const updateFromDealer = (state, { payload, meta }) => {
  const { dealerId } = meta;
  return { ...state, [dealerId]: payload.content.map(({ id }) => id) };
};

export default createReducer(initialState, {
  [types.FETCH_FIND_DEALER_OR_GROUP_SUCCESS]: updateFromDealer,
});
